
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return /^(5(099|117|154)|7(480|585|875)|9(324|391|78)|1545|1889|2086|2515|3807|4896|6803)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
